import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const SearchIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export default SearchIcon;
